"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var react_1 = require("react");
var react_2 = require("@nextui-org/react");
var main_1 = require("../../../../../reducers/slices/main");
var save_basket_abandonment_thunk_1 = require("../../../../../reducers/slices/basket/basket_abandonment/thunks/save_basket_abandonment_thunk");
var get_basket_abandonment_thunk_1 = require("../../../../../reducers/slices/basket/basket_abandonment/thunks/get_basket_abandonment_thunk");
var BASKET_ABANDONMENT_OPTIONS = [
    { value: "24", label: "24 Hours" },
    { value: "72", label: "3 Days" },
    { value: "120", label: "5 Days" },
    { value: "168", label: "7 Days" },
    { value: "336", label: "2 Weeks" },
    { value: "672", label: "4 Weeks" },
    { value: "2160", label: "3 Months" },
];
var BasketManagement = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_redux_1.useSelector)(function (state) { return state.basketAbandonmentState; }), basket_abandonment = _a.config, loading = _a.loading;
    var _b = (0, react_1.useState)({
        unit: "HOURS",
        value: "24",
    }), localConfig = _b[0], setLocalConfig = _b[1];
    (0, react_1.useEffect)(function () {
        if (basket_abandonment === null || basket_abandonment === void 0 ? void 0 : basket_abandonment.frequency) {
            setLocalConfig({
                unit: basket_abandonment.frequency.unit,
                value: String(basket_abandonment.frequency.value),
            });
        }
    }, [basket_abandonment]);
    (0, react_1.useEffect)(function () {
        var saved = localStorage.getItem("basket_frequency");
        var freq = { unit: "HOURS", value: "24" };
        if (saved) {
            try {
                freq = JSON.parse(saved);
            }
            catch (_a) { }
        }
        dispatch((0, get_basket_abandonment_thunk_1.fetchBasketAbandonmentConfig)(freq));
    }, [dispatch]);
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch((0, save_basket_abandonment_thunk_1.saveBasketAbandonmentConfig)({
                            frequency: localConfig,
                        })).unwrap()];
                case 1:
                    _a.sent();
                    localStorage.setItem("basket_frequency", JSON.stringify(localConfig));
                    dispatch((0, main_1.setMessageModal)({
                        title: "Success",
                        messages: ["Basket management settings updated successfully"],
                    }));
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    dispatch((0, main_1.setMessageModal)({
                        title: "Error",
                        messages: [(error_1 === null || error_1 === void 0 ? void 0 : error_1.message) || "Failed to update Basket management settings"],
                    }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-col gap-4" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-6" }, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ className: "text-lg font-semibold mb-2" }, { children: "Basket Abandonment Timeframe" })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "text-sm text-default-400 mb-2" }, { children: "Set how long a shopping basket should" })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "text-sm text-default-400 mb-2" }, { children: "remain inactive before it is considered abandoned." })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-col gap-2" }, { children: (0, jsx_runtime_1.jsx)(react_2.Select, __assign({ selectedKeys: new Set([localConfig.value]), onSelectionChange: function (keys) {
                                    var value = Array.from(keys)[0];
                                    setLocalConfig({ unit: "HOURS", value: value });
                                }, variant: "bordered" }, { children: BASKET_ABANDONMENT_OPTIONS.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_2.SelectItem, __assign({ value: option.value }, { children: option.label }), option.value)); }) })) }))] }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex justify-end" }, { children: (0, jsx_runtime_1.jsx)(react_2.Button, __assign({ color: "primary", isLoading: loading, onPress: handleSave }, { children: "Save Changes" })) }))] })) })));
};
exports.default = BasketManagement;
